import React from "react";
import { dealColumns } from "_constants";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormRow from "forms/components/FormRow";
import { CheckboxField } from "forms/fields";
import includes from "lodash/includes";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import styles from "forms/forms.css";

const { t } = new Translate("DealColumns");

export default class DealColumnsForm extends React.Component {
  componentWillUnmount() {
    if (this.props.dirty) this.props.handleSubmit();
  }

  render() {
    const { limitations } = this.props;
    const columns = includes(limitations, "assets")
      ? dealColumns.filter((c) => c !== "asset" && c !== "share_status")
      : dealColumns;

    return (
      <form className={styles.form}>
        <FormContainer>
          {columns.map((c) => (
            <FormRow columns={1} key={c}>
              <Field
                component={CheckboxField}
                isRequired={includes(["tenant", "activity", "share_status"], c)}
                label={t(`deal.${c}`)}
                name={c}
              />
            </FormRow>
          ))}
        </FormContainer>
      </form>
    );
  }
}

DealColumnsForm.propTypes = {
  dirty: PropTypes.bool,
  handleSubmit: PropTypes.func,
  limitations: PropTypes.arrayOf(PropTypes.string),
};
